export default "__VITE_ASSET__bd101c53__"